import * as types from 'store/modules/hres6ke/mutation-types'
import hres6ke from 'api/hres6ke'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import hres6keLabels from 'assets/labels/hres6ke'
import { hres6keColumns } from 'assets/columns/hres6ke'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6keLabels,
    columns: hres6keColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      dtestrt: '',
      timbstr: '',
      dteend: '',
      timbend: '',
      timdstr: '',
      timdend: '',
      timastr: '',
      timaend: ''
    },
    dropdowns: {
      codrem: {
        en: {},
        th: {}
      }
    }
  },
  getters: {
    [types.GET_HRES6KE_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6KE_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6KE_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6KE_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6KE_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6KE_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6KE_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES6KE_DROPDOWNS] (state) {
      return state.dropdowns
    }
  },
  mutations: {
    [types.SET_HRES6KE_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6KE_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6KE_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES6KE_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6KE_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6KE_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6KE_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES6KE_DROPDOWNS] (state, data) {
      state.dropdowns = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6KE_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6KE_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6KE_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6KE_COLUMNS_LABELS] ({ commit }) {
      hres6ke.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6KE_COLUMNS, data.labels)
          commit(types.SET_HRES6KE_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES6KE_INDEX] ({ commit }, searchParams) {
      hres6ke.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6KE_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRES6KE_INDEX, objData)
        })
    },
    [types.RECEIVED_HRES6KE_CREATE] ({ commit }, searchParams) {
      hres6ke.getCreate(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6KE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES6KE_DETAIL] ({ commit }, searchParams) {
      hres6ke.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6KE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES6KE_DROPDOWNS] ({ commit }) {
      hres6ke.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6KE_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_HRES6KE_SAVE] ({ commit, dispatch }, { saveParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: '<span class="text-red">' + constLabels('msgConfirmOT') + '</span><br>' + constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres6ke.postSave(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              let paramSearch = {
                p_dtereq: saveParams.dtereq,
                p_numseq: saveParams.numseq,
                p_codempid_query: saveParams.codempid
              }
              dispatch(types.RECEIVED_HRES6KE_DETAIL, paramSearch)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    },
    [types.POST_HRES6KE_CANCEL] ({ commit, dispatch }, { cancelParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres6ke.postCancel(cancelParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES6KE_INDEX, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6ke/index.js